import React from 'react'
import { CalendarCheck } from 'lucide-react'
import { SessionManager } from '../../utils'

export default function ActionPreventive(props) {

    const { text, route_name, onClick } = props

    var permission = JSON.parse(SessionManager.getSession('permission'))

    return (
        <>
            {(permission?.some(val => val.sub_action_name == route_name)) &&
                <CalendarCheck size={16} className='action-button text-primary me-3'
                    onClick={onClick}
                    data-tooltip-id="global-table-tooltip"
                    data-tooltip-content={text}
                    data-tooltip-place="bottom"
                    data-tooltip-class-name="bg-primary tooltip_msg"
                />
            }
        </>
    )
}
